import { render, staticRenderFns } from "./RedeemComplete.vue?vue&type=template&id=35b73d2c&scoped=true&"
import script from "./RedeemComplete.vue?vue&type=script&lang=js&"
export * from "./RedeemComplete.vue?vue&type=script&lang=js&"
import style0 from "./RedeemComplete.vue?vue&type=style&index=0&id=35b73d2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b73d2c",
  null
  
)

export default component.exports